/* eslint-disable  */
import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { connect } from 'react-redux';
import {
    Button, Table, Header, Checkbox
} from 'semantic-ui-react';
import { actions } from './sagaSlice';
import { FlexBox } from '../../styles/components';
import clone from 'lodash/cloneDeep';

import 'semantic-ui-css/semantic.min.css';

const Radio = props => (
    <div className='flex-column'>
        <label className='radio-label'>{props.label}</label>
        <input
            {...props}
            className='eval-radio'
            type='radio'
            onChange={props.input.onChange}
            value={props.input.value}
            name={props.input.name}
            checked={props.input.checked}
        />
    </div>
);

const TextArea = props => <textarea maxLength='3000' className='text-area' {...props} {...props.input} />;

// eslint-disable-next-line max-lines-per-function
const LongEvalForm = props => {

    const { evaluation, update, actualJobTitle } = props;

    console.log(evaluation)

    const onSubmit = values => {
        const payload = clone(values);
        payload.data.actual_job_title = actualJobTitle;
        update(payload);
    };

    const { completed, session } = evaluation;
    const frozen = session === 'frozen';

    return (
        <FinalForm
            initialValues={evaluation}
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine }) => (
                <form onSubmit={handleSubmit}>
                            <div style={{
                        padding: "10px 0px 10px 0px"
                    }}>                             
                    <Table celled className='pagebreak print-font'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='4'>
									Section I. <span style={{ marginLeft: '20px' }}>Employee Engagement</span>
                                </Table.HeaderCell>
                                <Table.HeaderCell className='blue-header header-resize' width='2'>
                                    <div>4= Exceeds Expectations </div>
                                    <div>3= Meet Expectations </div>
                                    <div>2= Needs Improvement </div>
                                    <div>1= Below Expectations</div>
                                </Table.HeaderCell>
                                <Table.HeaderCell className='blue-header' textAlign='center' width='5'>
									Comments
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {evaluation.data.default.map((question, i) => (
                                <Table.Row key={`default-${i}`}>
                                    <Table.Cell>
                                        <Header size='small' content={question.descriptor} subheader={question.text} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <div className='flex-space'>
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'4'} label='4' disabled={ completed || frozen } />
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'3'} label='3' disabled={ completed || frozen } />
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'2'} label='2' disabled={ completed || frozen } />
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'1'} label='1' disabled={ completed || frozen } />
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell>

                                        <Field component={TextArea} disabled={ completed || frozen } name={`data.default[${i}].comments`} />

                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    </div>
                            <div style={{
                        padding: "10px 0px 10px 0px"
                    }}>                    
                    <Table celled className='pagebreak print-mt print-font'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='4'>
                                    <strong>
										Section II. <span style={{ marginLeft: '20px' }}>Specific Responsibilities</span>{' '}
                                    </strong>
                                </Table.HeaderCell>
                                <Table.HeaderCell className='blue-header header-resize' width='2' textAlign='center' />
                                <Table.HeaderCell className='blue-header' width='5' textAlign='center' />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {evaluation.data.title.map((question, i) => (
                                <Table.Row key={`title-${i}`}>
                                    <Table.Cell>
                                        <Header size='small' content={question.descriptor} subheader={question.text} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <div className='flex-space'>
                                            <Field component={Radio} type='radio' name={`data.title[${i}].rating`} value={'4'} label='4' disabled={ completed || frozen } />
                                            <Field component={Radio} type='radio' name={`data.title[${i}].rating`} value={'3'} label='3' disabled={ completed || frozen } />
                                            <Field component={Radio} type='radio' name={`data.title[${i}].rating`} value={'2'} label='2' disabled={ completed || frozen } />
                                            <Field component={Radio} type='radio' name={`data.title[${i}].rating`} value={'1'} label='1' disabled={ completed || frozen } />
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell>

                                        <Field component={TextArea} name={`data.title[${i}].comments`} disabled={ completed || frozen } />

                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    </div>

                    <div style={{
                        padding: "10px 0px 10px 0px"
                    }}>           
                    <Table className='print-mt print-font'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='4'>
                                    <strong>
										Section III. <span style={{ marginLeft: '20px' }}>Goals</span>{' '}
                                    </strong>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        {evaluation.date.substring(0, 4) === '2024' && ['community_manager', 'assistant_community_manager'].includes(evaluation.employee.title.name)  ?
                        (<Table.Body>
                            {/* FIXING ORDER  */}
                            {Object.entries({
                                one: evaluation.goals.one,
                                two: evaluation.goals.two,
                                three: evaluation.goals.three
                            }).map(([key, goal]) => (
                                <React.Fragment key={`goals-${key}`}>
                                    <Table.Row>
                                        <Table.Cell className='goal-title'>
                                            <label >Goal {key}</label>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className='goal-text'>

                                            <Field component={TextArea} name={`goals[${key}].goal`} disabled={ completed || frozen }/>

                                        </Table.Cell>
                                    </Table.Row>
                                </React.Fragment>
                            ))}
                        </Table.Body>) : (

                            <Table.Body>
                                {/* FIXING ORDER  */}
                                {Object.entries({
                                    one: evaluation.goals.one,
                                    two: evaluation.goals.two,
                                    three: evaluation.goals.three,
                                    four: evaluation.goals.four,
                                    five: evaluation.goals.five
                                }).map(([key, goal]) => (
                                    <React.Fragment key={`goals-${key}`}>
                                        <Table.Row>
                                            <Table.Cell className='goal-title'>
                                                <label>Goal {key}</label>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell className='goal-text'>

                                                <Field component={TextArea} name={`goals[${key}].goal`} disabled={ completed || frozen }/>

                                            </Table.Cell>
                                        </Table.Row>
                                    </React.Fragment>
                                ))}
                            </Table.Body>
                        )}
                    </Table>
                    </div>
                    <div style={{
                        padding: "10px 0px 10px 0px"
                    }}>

                { evaluation.date.substring(0, 4) === '2024' && ['community_manager'].includes(evaluation.employee.title.name)  ? 
                    (<Table>
                    <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='4'>
                                    <strong>
										Section IV. <span style={{ marginLeft: '20px' }}>Property Goals</span>{' '}
                                    </strong>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                                {Object.entries({
                                    renewals: evaluation?.property_goals?.renewals,
                                    occupancy: evaluation?.property_goals?.occupancy,
                                    evictions: evaluation?.property_goals?.evictions
                                }).map(([key, goal]) => (
                                    <React.Fragment key={`property_goals-${key}`}>
                                        <Table.Row>
                                            <Table.Cell className='goal-title'>
                                                <label>{ key.charAt(0).toUpperCase() + key.slice(1)}</label>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<label>Goals</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label>Achievement</label>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell className='goal-text'>

                                                <Field component="input" type="number" label='4'  placeholder={0} name={`property_goals[${key}].goal`} disabled={ completed || frozen }/>% &nbsp;&nbsp;&nbsp;&nbsp;
                                                <Field component="input" type="number" label='4'  placeholder={0} name={`property_goals[${key}].current`} disabled={ completed || frozen }/>%

                                            </Table.Cell>
                                        </Table.Row>
                                    </React.Fragment>

                                ))}
                                    <React.Fragment key={`property_goals-coment`}>
                                        <Table.Row>
                                            <Table.Cell className='goal-title'>
                                                <label></label>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell className='goal-text'>

                                                <Field component={TextArea} name={`property_goals_comment`} disabled={ completed || frozen }/>

                                            </Table.Cell>
                                        </Table.Row>
                                    </React.Fragment>
                            </Table.Body>
                    </Table> ) : (
                        <div></div>
                    )}

                    <Table className='print-mt print-font' id={'eval-section-comments'}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='4'>
                                { evaluation.date.substring(0, 4) === '2024' && ['community_manager'].includes(evaluation.employee.title.name)  ? 
                                    <strong>
										Section V. <span style={{ marginLeft: '20px' }}>Comments</span>{' '}
                                    </strong>
                                    :
                                    <strong>
                                    Section IV. <span style={{ marginLeft: '20px' }}>Comments</span>{' '}
                                </strong> }

                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                    <Table.Body>
                        <React.Fragment>
                            <Table.Row>
                                <Table.Cell className='comment-area'>
                                    <Field id={'eval-section-comments-textarea'} component={TextArea} name= {'comments'}/>
                                </Table.Cell>
                            </Table.Row>
                        </React.Fragment>
                    </Table.Body>
                    </Table>

                    {evaluation.date.substring(0, 4) === '2024' && ['chief_engineer', 'assistant_community_manager'].includes(evaluation.employee.title.name)  ? (<Table className='print-mt print-font' id={'eval-section-regional-comments'}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='4'>
                                
                                {evaluation.date.substring(0, 4) === '2024' && ['assistant_community_manager'].includes(evaluation.employee.title.name)  ? 
                                    <strong>
										Section VI. <span style={{ marginLeft: '20px' }}>Regional’s Feedback</span>{' '}
                                    </strong>
                                    :
                                    <strong>
                                    Section V. <span style={{ marginLeft: '20px' }}>Regional’s Feedback</span>{' '}
                                </strong>
                                }
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <React.Fragment>
                                <Table.Row>
                                    <Table.Cell className='comment-area'>
                                        <Field id={'eval-section-regional-comments-textarea'} component={TextArea} name= {'regional_comment'}/>
                                    </Table.Cell>
                                </Table.Row>
                            </React.Fragment>
                        </Table.Body>
                    </Table>) : (<div></div>)}
                    </div>


                    <FlexBox justifyContent='space-between'>
                        <Button color='green' type='submit' disabled={submitting || pristine || frozen}>
							SAVE EVALUATION
                        </Button>

                        <Field name='completed'>
                            {({ input }) => (

                                <Checkbox
                                    disabled={frozen}
                                    label='COMPLETED'
                                    toggle
                                    onChange={(e, { checked }) => input.onChange(checked)}
                                    checked={input.value}
                                />
                            )}
                        </Field>

                    </FlexBox>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '400px', paddingTop: '4rem' }}>
                        <div style={{ borderBottom: '1px solid black', marginBottom: '20px', width: '75%' }}></div>
                        <p style={{ marginTop: '0' }}>Supervisor</p>
                        
                        <div style={{ borderBottom: '1px solid black', marginBottom: '20px', width: '75%', paddingTop: '2rem' }}></div>
                        <p style={{ marginTop: '0' }}>Team Member</p>
                    </div>
                </form>
            )}
        />
    );
};

export default connect(
    null,
    actions
)(LongEvalForm);
